export enum AuthenticateErrorCode {
    USERNAME_OR_PASSWORD_INVALID = 'usernamePasswordInvalid',
    ACCOUNT_LOCKED = 'userAccountLocked'
}
